import { useQuery } from "@tanstack/react-query"
import { subscriptionApi } from "../../services/api"
import { useAuthStore } from "../../store/authStore"


export function usePlan() {
  const orgId = useAuthStore((state) => state.orgId)
  return useQuery({
    queryKey: [orgId, 'price-plans'],
    queryFn: () => subscriptionApi.getPlans(),
    enabled: !!orgId,
  })
}

/**
 * Hook for verifying payment with query params
 * @param params - Query string from payment gateway redirect
 * @param enabled - Whether to run the query immediately
 */
export function useVerifyPaymentWithParams(params: string | null, enabled: boolean = true) {
  const orgId = useAuthStore((state) => state.orgId)
  return useQuery({
    queryKey: [orgId, 'verify-payment', params],
    queryFn: () => subscriptionApi.verifyPayment(params!),
    enabled: !!params && enabled && !!orgId,
    retry: false, // Don't retry failed payment verifications
  })
}